export const ECONNABORTED_ERROR_CODE = 'ECONNABORTED';
export class LBError extends Error {
    constructor(message, displayMessage, status) {
        const proto = new.target.prototype;
        super(message);
        Object.defineProperty(this, "displayMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // tslint:disable-next-line:variable-name
        Object.defineProperty(this, "__proto__", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isUnauthorizedError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isForbiddenError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isNotFoundError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isBadRequestError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isMaintenanceError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.__proto__ = proto;
        this.displayMessage = displayMessage;
        this.status = status;
    }
}
export class APIServerError extends LBError {
}
export class ASPServerError extends LBError {
}
export class BigQueryError extends LBError {
}
export class FormError extends LBError {
}
export class NotFoundError extends APIServerError {
    constructor(message, displayMessage, status) {
        super(message, displayMessage, status);
        this.isNotFoundError = true;
    }
}
export class BadRequestError extends APIServerError {
    constructor(message, displayMessage, status) {
        super(message, displayMessage, status);
        this.isBadRequestError = true;
    }
}
export class UnauthorizedError extends APIServerError {
    constructor(message, displayMessage, status) {
        super(message, displayMessage, status);
        this.isUnauthorizedError = true;
    }
}
export class ForbiddenError extends APIServerError {
    constructor(message, displayMessage, status, errorCode) {
        super(message, displayMessage, status);
        Object.defineProperty(this, "isQuit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isDormant", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isFuture", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isPaymentNotFound", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isPaymentExpired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.isForbiddenError = true;
        this.isQuit = errorCode === 'quit_user';
        this.isDormant = errorCode === 'dormant_user';
        this.isFuture = errorCode === 'future_user'; // megalosで有効期限が未来になるユーザーがいる
        this.isPaymentNotFound = errorCode === 'payment_not_found';
        this.isPaymentExpired = errorCode === 'payment_expired';
    }
}
export class UnderMaintenance extends APIServerError {
    constructor(message, status, maintenance) {
        super(message, 'サーバメンテナンス中', status);
        Object.defineProperty(this, "maintenance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.isMaintenanceError = true;
        this.maintenance = maintenance;
    }
}
